<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onClickRowItem"
        >
            <template v-slot:[`item.displayMessage`]="{ item }">
                <div v-if="item.displayMessage">
                    {{ item.displayMessage }}
                </div>
                <div
                    v-else
                    class="grey--text">
                    {{ $t('noData') }}
                </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <div
                    class="action-button mx-1 grey--text text--darken-2 rounded clickable"
                    @click="$emit('edit', item)">
                    <icon
                        value="edit"
                        size="18px"/>
                </div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import { TableMixinFactory } from '@/mixins/TableMixin'

export default {
    name: 'IBeaconTable',

    components: {
        BaseTable
    },

    mixins: [
        TableMixinFactory({
            itemMapFunc: function (item) {
                let defaultMessage
                let preferedMessage
                // eslint-disable-next-line
                item?.broadcastMessage?.messages?.forEach(message => {
                    if (message.langCode === this.$constant.locale.DEFAULT_IBEACON_LOCALE) {
                        defaultMessage = message
                    }

                    if (message.langCode === this.$i18n.locale) {
                        preferedMessage = message
                    }
                })
                return {
                    ...item,
                    displayMessage: preferedMessage?.title ?? defaultMessage?.title
                }
            }
        })
    ],

    data () {
        return {
            headers: [
                {
                    text: this.$t('ibeacon.table.major'),
                    value: 'major',
                    width: '60px',
                    sortable: false
                },
                {
                    text: this.$t('ibeacon.table.minor'),
                    value: 'minor',
                    width: '60px',
                    sortable: false
                },
                {
                    text: this.$t('ibeacon.table.uuid'),
                    value: 'uuid',
                    sortable: false
                },
                {
                    text: this.$t('ibeacon.table.message'),
                    value: 'displayMessage',
                    sortable: false
                },
                {
                    text: '',
                    value: 'action',
                    align: 'right',
                    sortable: false
                }
            ]
        }
    },

    methods: {
        onClickRowItem (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped></style>
